<template>
    <div>
        <div
            :class="hasError ? 'input-error' : ''"
            class="p-0"
        >
            <ion-input
                class="custom-border"
                :label="label"
                label-placement="floating"
                :type="inputType"
                :inputmode="inputMode"
                :pattern="inputType"
                :disabled="readonly"
                :value="modelValue"
                :placeholder="placeholder"
                @input="onChanged"
            >
                <ion-input-password-toggle
                    slot="end"
                    v-if="inputType === 'password'"
                ></ion-input-password-toggle>
            </ion-input>
        </div>
        <ion-text v-if="hasError">
            {{ errorMsg }}
        </ion-text>
    </div>
</template>

<script
    setup
    lang="ts"
>

import { IonInput, IonInputPasswordToggle, IonText } from '@ionic/vue';
import { computed, PropType } from "vue";

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    errors: {
        type: Array<any>
    },
    placeholder: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    inputType: {
        type: String as PropType<'text' | 'email' | 'password'>,
        default: 'text'
    },
    readonly: {
        type: Boolean,
        default: false
    },
});

const emit = defineEmits(['update:modelValue']);

function onChanged(e: any) {
    emit('update:modelValue', e.target.value);
}

const hasError = computed(() => {
    return props.errors && props.errors.length > 0 && props.errors[0].$message;
});
const errorMsg = computed(() => {
    return props.errors && props.errors.length > 0 ? props.errors[0].$message : '';
});

const inputMode = computed(() => {
    return props.inputType === 'email' ? 'email' : 'text';
});

</script>

<style scoped>
ion-label {
    color: var(--black100);
}


div.input-error {
    --highlight-background: var(--error100);
}

ion-text {
    color: var(--error100, red);
    padding: 0.5rem 0;
    font-size: 12px;
    font-style: italic;
    align-items: center;
    text-align: end;
    display: block;
}

ion-input.custom-border {
   border-bottom: var(--ion-border-color, gray) 0.5px solid;
}
</style>